export const NAVIGATION_THROTTLE_DELAY = 100;
